export default __webpack_public_path__ + "static/char-37-4380ff78170f666dfd843ad0431c9368.webp";